import CustomChip from './CustomChip';

export default CustomChip;
